import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { VaultNavigation } from 'vault/components/VaultNavigation';
import { MainLayout } from 'layouts/MainLayout';
import { EditionsGridContainer } from 'editions/EditionsGridContainer';
import { PlaylistsContainer } from 'playlists/PlaylistsContainer';
import { Spinner } from 'components/Spinner';

import * as Types from 'types';

import { fetchEditions } from 'features/editions/actions';

type StateProps = {
  isEmpty: boolean;
  initialFetchingDone: boolean;
  artStreamActive: boolean;
};

type DispatchProps = {
  fetchEditions: () => void;
};

type Props = StateProps & DispatchProps;

const Vault: React.FC<Props> = ({ fetchEditions, ...props }) => {
  React.useEffect(() => {
    $('html').addClass('layout--vault');
    fetchEditions();
  }, []);

  const { isEmpty, artStreamActive, initialFetchingDone } = props;

  const showGettingStarted = isEmpty && !artStreamActive && initialFetchingDone;

  return (
    <MainLayout background='dark'>
      {!initialFetchingDone && (
        <Spinner className='square-spin--light square-spin--small translate-into-middle' />
      )}
      {initialFetchingDone && !showGettingStarted && <VaultNavigation />}
      <Switch>
        <Route exact path={Routes.vault_path()} component={EditionsGridContainer} />
        <Route exact path={Routes.vault_edition_path(':id')} component={EditionsGridContainer} />
        <Route exact path={Routes.edit_vault_playlist_path(':id')} component={PlaylistsContainer} />
        <Route exact path={Routes.vault_playlist_path(':id')} component={PlaylistsContainer} />
        <Route exact path={Routes.vault_playlists_path()} component={PlaylistsContainer} />
      </Switch>
    </MainLayout>
  );
};

const mapStateToProps = ({ editions, currentUser }: Types.RootState) => ({
  isEmpty: Object.keys(editions.byId).length === 0 && !editions.isFetching,
  artStreamActive: Boolean(currentUser.user && currentUser.user.artStreamActive),
  initialFetchingDone: !editions.isInitial,
});

const mapDispatchToProps = { fetchEditions };

export const VaultContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Vault));
